import FnrTypography from "UI/FnrTypography";
import { useStartOver } from "Login/TwoFA/API/queryHooks";
import { useTwoFAContext } from "Login/TwoFA/TwoFA";

import FnrTextButton from "UI/FnrTextButton";
import FnrVerticalGap from "UI/commonContainers/FnrVerticalGap";

const MissingNetworksLink = () => {
  const { variant, isDark, remoteCancelRef } = useTwoFAContext();
  const [{ isLoading }, startOver] = useStartOver({ variant, remoteCancelRef });

  return (
    <FnrVerticalGap gap={4} data-cy="MissingNetworksLink_Container">
      <FnrTypography
        type="copy"
        fontSize="sm"
        bold
        color={isDark ? "textLight" : "text"}
      >
        Not seeing your network?
      </FnrTypography>
      <FnrTextButton
        fontSize="xs"
        color="blue"
        subtleHover
        onClick={startOver}
        isLoading={isLoading}
        icon="fa-unlock fas"
        iconSide="right"
        reducedYPadding
      >
        Log in via email or text code to see all your accounts.
      </FnrTextButton>
    </FnrVerticalGap>
  );
};

export default MissingNetworksLink;
